// extracted by mini-css-extract-plugin
export default {"container":"BoardAnnouncement_container__6R12Y","search":"BoardAnnouncement_search__1eQCZ"};